import { ARRAY_OF_MIXED_ORDERS_01, PENDING_DATA_01 } from '../../../mocks/order-report.data';
import { concat, NEVER, Observable, of, timer } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { IBlotterAdapter } from './blotter-adapter.interface';
import { IBlotterTransaction, ORDER_KEY } from '../../../interfaces';
import { injectable } from 'inversify';

@injectable()
export class BlotterAdapterMock implements IBlotterAdapter {

    ordersObservable = (): Observable<IBlotterTransaction> => concat(
        of(ARRAY_OF_MIXED_ORDERS_01).pipe(
            map(orders => ({
                newItems: orders,
                updated: [],
                deletedKeys: [],
                total: orders.length,
                key: ORDER_KEY,
            } as IBlotterTransaction))),
        timer(10_000, 5_000).pipe(
            map(() => ({
                newItems: [],
                updated: [
                    {
                        ...PENDING_DATA_01,
                        fillPercent: Math.floor(Math.random() * 100),
                        requestedAmount: Math.floor(Math.random() * 10_000),
                        counterFilledAmount: Math.floor(Math.random() * 10_000),
                    },
                ],
                deletedKeys: [],
                total: 1,
                key: ORDER_KEY,
            } as IBlotterTransaction))),
        of(PENDING_DATA_01).pipe(
            delay(1000),
            map(order => ({
                newItems: [],
                updated: [ { ...order, state: 'filled' } ],
                deletedKeys: [],
                total: 1,
                key: ORDER_KEY,
            } as IBlotterTransaction)),
        ),
        NEVER,
    );
}
